import React, { useState } from 'react';

export const FormControlLabelAndPopover = ({field, loading} : ControlParameters) => {
  return(
    <div className={field.properties.fielddescription || loading ? 'label-and-popover' : 'label__without-popover'}>
      <FormControlLabel field={field} />
      <FormControlPopover field={field} />
      <FormControlSpinner loading={loading} />
    </div>
  );
};

export const FormControlLabel = ({field}) => {
  return (
    <label htmlFor={field["@column"]}>
      {field.properties.fieldcaption}{field.properties.explanationtext ? ` (${field.properties.explanationtext})` : ''}{!field["@allowempty"] ? " *" : ""}
    </label>
  );
};

export const FormControlSpinner = ({loading}) => {

  return ( !!loading && <div className="spin-animation spinning-icon"></div> );
};

export const FormControlPopover = ({field}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSetOpen = () => { 
    setIsOpen(!isOpen);
  };

  const handleSetClose = () => { 
    setIsOpen(false);
  };

  if(!field.properties.fielddescription) {
    return (null);
  }

  return (
    <a href="javascript:void(0);" title={field.properties.fielddescription} className="form-control__popover-icon icon icon-information"
      onBlur={handleSetClose}
      onClick={handleSetOpen}
    >
       {(() => {
        if(isOpen){
          return (  
            <span className="form-control__popover">{field.properties.fielddescription}</span>
          );
        }
      })()}
    </a>
  );
};